module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-header@3x-ac5de495c16ccdc854879a4fcc7f48cc.png";